var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFetchingContacts
    ? _c(
        "section",
        [_c("spinner-loader", { attrs: { loading: _vm.isFetchingContacts } })],
        1
      )
    : _vm.errored
    ? _c("section", [_c("p", [_vm._v("An error occurred.")])])
    : _vm.contacts.length < 1
    ? _c(
        "section",
        [
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticStyle: { "margin-top": "4px" },
              on: { click: _vm.handleShowAddContactModal },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("contacts.add_contact")) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "contact-modal",
            { ref: "addContactModal", staticClass: "contact-modal-btn-new" },
            [
              _c(
                "template",
                { slot: "submit" },
                [
                  _c("b-button", { on: { click: _vm.handleAddContact } }, [
                    _vm._v("Save"),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      )
    : _c(
        "section",
        { staticClass: "content-container" },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                {
                  staticClass: "search-header",
                  attrs: { "align-h": "center" },
                },
                [
                  _c(
                    "contact-modal",
                    {
                      ref: "addContactModal",
                      staticClass: "contact-modal-btn-new",
                    },
                    [
                      _c(
                        "template",
                        { slot: "submit" },
                        [
                          _c(
                            "b-button",
                            { on: { click: _vm.handleAddContact } },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "6" } },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-input", {
                            attrs: { placeholder: _vm.$t("search") },
                            model: {
                              value: _vm.filter,
                              callback: function ($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticStyle: { "margin-top": "4px" },
                          on: { click: _vm.handleShowAddContactModal },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("contacts.add_contact")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLoading
            ? _c("b-table", {
                staticClass: "contacts-table",
                attrs: {
                  items: _vm.contacts,
                  fields: _vm.fields,
                  filter: _vm.filter,
                  hover: _vm.hover.show,
                  striped: "",
                  fixed: "",
                },
                on: { "row-clicked": _vm.rowClicked },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(name)",
                      fn: function (row) {
                        return [_c("h5", [_vm._v(_vm._s(row.item.name))])]
                      },
                    },
                  ],
                  null,
                  false,
                  93965380
                ),
              })
            : _c(
                "div",
                { staticClass: "fixed-center loadingSpace" },
                [
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        visible: _vm.isLoading,
                        "content-class": "fetching-spinner-content",
                        centered: "",
                        "hide-header": "",
                        "hide-footer": "",
                        "hide-header-close": "",
                        "no-close-on-esc": "",
                        "no-close-on-backdrop": "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "default" }, slot: "default" },
                        [
                          _c("div", { staticClass: "loading-message" }, [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("loading_contacts"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("spinner-loader"),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "contact-modal",
            { ref: "editContactModal", staticClass: "contact-modal-btn-new" },
            [
              _c(
                "template",
                { slot: "submit" },
                [
                  _c("b-button", { on: { click: _vm.handleUpdateContact } }, [
                    _vm._v("Update"),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n    You don't have any guest profiles yet. "),
      _c("br"),
      _vm._v('Create your first one by\n    clicking "New Guest."\n  '),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }